export const TRIAL_DEFAULT_DAYS = 14;

const TRIAL_FEATURES_TEXT =
  "3 templates, up to 3 managers, and real rounds you can run today. No setup fees, no IT project, no commitment.";

export function computeDaysRemainingFromEndDate(endDate) {
  if (!endDate) return null;
  const end = new Date(endDate);
  if (Number.isNaN(end.getTime())) return null;
  const ms = end.getTime() - Date.now();
  if (ms <= 0) return 0;
  return Math.ceil(ms / (1000 * 60 * 60 * 24));
}

export function getTrialVersionLimitations(daysRemaining) {
  const prefix = formatTrialDaysPrefix(daysRemaining);
  return `${prefix}: ${TRIAL_FEATURES_TEXT}`;
}

function formatTrialDaysPrefix(daysRemaining) {
  if (daysRemaining == null || Number.isNaN(Number(daysRemaining))) {
    return `Your ${TRIAL_DEFAULT_DAYS}-day trial`;
  }

  const days = Math.max(0, Math.ceil(Number(daysRemaining)));

  if (days <= 0) {
    return "Your trial ends today";
  }
  if (days === 1) {
    return "Your 1-day trial (1 day left)";
  }
  return `Your ${days}-day trial (${days} days left)`;
}

export function isTrialUser(adminData) {
  const d = adminData && adminData.data;
  if (!d) return false;
  if (d.isPaid === true) return false;
  return d.isTrial === true;
}

export function isTrialPlanName(planName) {
  const p = String(planName || "")
    .trim()
    .toLowerCase();
  return p === "trial" || p === "free";
}
